var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14645 4.64645C2.34171 4.45118 2.65829 4.45118 2.85355 4.64645L8.5 10.2929L14.1464 4.64645C14.3417 4.45118 14.6583 4.45118 14.8536 4.64645C15.0488 4.84171 15.0488 5.15829 14.8536 5.35355L8.85355 11.3536C8.65829 11.5488 8.34171 11.5488 8.14645 11.3536L2.14645 5.35355C1.95118 5.15829 1.95118 4.84171 2.14645 4.64645Z",
    fill: "#424242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.b34d2b75da83c7ec60d1c62d43e458cd.svg";
export { ForwardRef as ReactComponent };